import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IS_API_GATEWAY } from '@personal-area/common';
import { ExtendedSocialUser, socialNetworksURLs } from '@personal-area/global/social-authorization/models';

interface AppleInfoResponse {
  id: string;
  email: string;
  name: string;
  photoURL: string;
  authToken: string;
  provider: string;
}

@Injectable({ providedIn: 'root' })
export class AppleAuthApiService {
  private _http = inject(HttpClient);

  public getAppleInfo(oneTimeToken: string): Observable<ExtendedSocialUser | null> {
    return this._http.get<AppleInfoResponse>(socialNetworksURLs.appleInfo, {
      params: { oneTimeToken },
      context: new HttpContext().set(IS_API_GATEWAY, true)
    }).pipe(
      map(response => ({
        id: response.id,
        email: response.email,
        name: response.name,
        photoUrl: response.photoURL,
        authToken: response.authToken,
        provider: response.provider,
        firstName: '',
        lastName: '',
      }))
    );
  }
}
